<div class="layout-topbar" *ngIf="!_router.url.includes('company-detail') && !isFrozenColumn" >
    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>
    <div class="layout-topbar-menu mr-4"  (click)="accountMenu.toggle($event)"
        [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <div>
        <p class=" flex align-items-center cursor-pointer profile-image text-username"   *ngIf="!userImage"  >{{userName.charAt(0).toUpperCase()}}</p>
    </div>
        <img class=" flex align-items-center cursor-pointer profile-image" src="{{userImage}}" *ngIf="userImage" >
        &nbsp; 
            <i class="pi pi-angle-down relative top-1"></i> 
        
    </div>
    <p-menu #accountMenu appendTo="body" [popup]="true" [model]="items"></p-menu>
</div>
<div class="layout" *ngIf="isFrozenColumn">
<button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
    <i class="pi pi-bars"></i>
</button>
</div>

<p-dialog
    header="Schedule Daily Email Report"
    [(visible)]="dailyReportDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '42rem', maxWidth: '95vw' }"
    [breakpoints]="{ '960px': '95vw', '640px': '100vw' }"
    styleClass="daily-report-dialog">
    <div class="daily-report-body">
        <p class="daily-report-subtitle">Configure the emails that should receive the report each day.</p>

        <div class="daily-report-loading" *ngIf="isDailyReportLoading">
            <div class="daily-report-spinner"></div>
            <p>Loading report settings...</p>
        </div>

        <div class="daily-report-field" *ngIf="!isDailyReportLoading">
            <label class="daily-report-label">Email recipients</label>
            <p-chips
                [(ngModel)]="companyReportEmails"
                separator=","
                placeholder="Enter email and press comma"
                [addOnBlur]="true"
                [allowDuplicate]="false"
                class="daily-report-chips">
                <ng-template let-email pTemplate="item">
                    <span class="daily-report-chip" [class.daily-report-chip-invalid]="isDailyReportEmailInvalid(email)">
                        <span>{{ email }}</span>
                    </span>
                </ng-template>
            </p-chips>
            <small class="daily-report-help">Use comma separated emails. Invalid emails will be flagged before saving.</small>
        </div>

        <div class="daily-report-field" *ngIf="!isDailyReportLoading">
            <label class="daily-report-label">Time</label>
            <p-dropdown
                [(ngModel)]="selectedEmailTime"
                [options]="emailTimeOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select time"
                [appendTo]="'body'"
                [scrollHeight]="'240px'"
                [autoDisplayFirst]="false"></p-dropdown>
            <small class="daily-report-help">Times are listed in 1 hour gaps.</small>
        </div>

        <p class="daily-report-error" *ngIf="dailyReportError && !isDailyReportLoading">{{ dailyReportError }}</p>
    </div>

    <ng-template pTemplate="footer">
        <button pButton type="button" class="p-button-text" label="Cancel" (click)="dailyReportDialogVisible = false" [disabled]="isDailyReportLoading"></button>
        <button pButton type="button" label="Save" (click)="saveDailyReportSetting()" [loading]="isDailyReportLoading" [disabled]="isDailyReportLoading || !companyReportEmails.length"></button>
    </ng-template>
</p-dialog>


